import React, { useState, useEffect, useMemo } from "react";
import { CacheProvider } from "@emotion/react";
import rtlPlugin from "stylis-plugin-rtl";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import { useMediaQuery } from "react-responsive";
import getReq from "../interface/getRequestinterface";
import { getRequest } from "../request";
import { toast } from "react-toastify";
import {
  Alert,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import jwtDecode from "jwt-decode";
import Loading from "./loading";
import { useNavigate } from "react-router-dom";
import picture from "../css/No-data-amico.svg";

const styles = {
  mainContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "calc(100vh - 64px)",
  },
  tableContainer: {
    width: "50rem",
  },
  tableHeader: {
    backgroundColor: "#0C3148",
    color: "#fff",
  },
  modalStyle: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    display: "flex",
    flexDirection: "column",
    borderRadius: "0.3rem",
  },
  modalReturnBtn: {
    width: "50%",
    backgroundColor: "#D22027",
    "&:hover": {
      backgroundColor: "#99191e",
    },
  },
  modalAddBtn: {
    width: "50%",
  },
  EditUserBtn: {
    backgroundColor: "#308703",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#1e5800",
    },
  },
  noDataContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
};

interface ReqHistory {
  amount: number;
  currencyName: string;
  destinationCountry: string;
  nationalId: string;
  requestRegistrationShamsiInt: number;
}
function AdminRequestHistory() {
  const reqDetails: any = JSON.parse(localStorage.getItem("requestDetails")!);
  const [requestHistory, setRequestHistory] = useState<Array<ReqHistory>>([]);
  const [page, setPage] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const [rowsPerPage, setRowsPerPage] = useState<number>(5);

  const isDesktop = useMediaQuery({
    query: "(min-width: 1224px)",
  });

  const isTablet = useMediaQuery({
    query: "((min-width:650px) and (max-width: 900px))",
  });

  const isMobile = useMediaQuery({
    query: "(max-width: 400px)",
  });

  const cacheRtl = useMemo(() => {
    return createCache({
      key: "muirtl",
      stylisPlugins: [prefixer, rtlPlugin],
    });
  }, []);
  let decode: any = {};
  useEffect(() => {
    if (token) {
      decode = jwtDecode(token);
    }
    fetchUserHistory();
  }, []);
  const fetchUserHistory = async () => {
    if (decode.role === "Admin" || decode.role === "Expert") {
      if (reqDetails) {
        const { data, error }: getReq = (await getRequest(
          `${process.env.REACT_APP_BASE_URL}/User/UserRequestsHistoryByAdmin?requestCode=${reqDetails?.requestNumber}`
        )) as getReq;
        if (!error) {
          setRequestHistory(data);
          setIsLoading(true);
        } else {
          toast.error(error);
        }
      } else {
        toast.error("شماره درخواست مورد نظر را جستجو کنید");
        navigate("/searchRequest");
      }
    } else {
      const { data, error }: getReq = (await getRequest(
        `${process.env.REACT_APP_BASE_URL}/User/UserRequestsHistory`
      )) as getReq;
      if (!error) {
        setRequestHistory(data);
        setIsLoading(true);
      } else {
        toast.error(error);
      }
    }
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <CacheProvider value={cacheRtl}>
      <div className="background">
        {isLoading ? (
          <>
            <div
              className="container"
              style={isDesktop ? undefined : { marginTop: "3rem" }}
            >
              <Alert
                severity="info"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "1.5rem",
                }}
              >
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <Typography variant="h4" sx={{ fontWeight: "bold" }}>
                    تاریخچه درخواست ها
                  </Typography>
                </Box>
              </Alert>
              {requestHistory.length ? (
                <div style={{ boxShadow: "1px 1px 2px #efefef" }}>
                  <TableContainer
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      width: "fit-content",
                    }}
                  >
                    <Table stickyHeader aria-label="sticky table">
                      <TableHead>
                        <TableRow>
                          <TableCell
                            className="ratesTh"
                            style={{ width: "10rem" }}
                            align="center"
                            sx={styles.tableHeader}
                          >
                            نوع ارز
                          </TableCell>
                          <TableCell
                            className="ratesTh"
                            style={{ width: "10rem" }}
                            align="center"
                            sx={styles.tableHeader}
                          >
                            کشور مقصد
                          </TableCell>
                          <TableCell
                            className="ratesTh"
                            style={{ width: "10rem" }}
                            align="center"
                            sx={styles.tableHeader}
                          >
                            مقدار
                          </TableCell>
                          <TableCell
                            className="ratesTh"
                            style={{ width: "10rem" }}
                            align="center"
                            sx={styles.tableHeader}
                          >
                            تاریخ ثبت سفارش
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {requestHistory
                          .slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                          .map((row, index) => {
                            return (
                              <TableRow
                                key={index}
                                className="ratesTr"
                                sx={{
                                  "&:last-child , &:last-child": { border: 0 },
                                }}
                              >
                                <TableCell align="center" className="ratesTd">
                                  {row.currencyName}
                                </TableCell>
                                <TableCell align="center" className="ratesTd">
                                  {row.destinationCountry}
                                </TableCell>
                                <TableCell align="center" className="ratesTd">
                                  {row.amount.toLocaleString()}
                                </TableCell>
                                <TableCell align="center" className="ratesTd">
                                  {row.requestRegistrationShamsiInt
                                    .toString()
                                    .substring(0, 4) +
                                    "/" +
                                    row.requestRegistrationShamsiInt
                                      .toString()
                                      .substring(4, 6) +
                                    "/" +
                                    row.requestRegistrationShamsiInt
                                      .toString()
                                      .substring(6, 8)}
                                </TableCell>
                              </TableRow>
                            );
                          })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {requestHistory.length > 10 ? (
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25]}
                      component="div"
                      labelRowsPerPage={"تعداد سطر های هر صفحه"}
                      count={requestHistory.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                  ) : null}
                </div>
              ) : (
                <Box sx={styles.noDataContainer}>
                  <img
                    src={picture}
                    alt=""
                    style={isMobile ? {} : { height: "80vh" }}
                  />
                </Box>
              )}
            </div>
            :
          </>
        ) : (
          <div
            style={{
              width: "100vw",
              height: "calc( 100vh - 64px)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Loading type="cylon" color="#000" />
          </div>
        )}
      </div>
    </CacheProvider>
  );
}

export default AdminRequestHistory;
